import { FormInputProps } from '@lib/ui-components';
import { Controller } from 'react-hook-form';
import React from 'react';
import { TextField } from '@mui/material';
import { HelperText } from './helper-text';

export interface FormInputTextAreaProps extends FormInputProps {
  rows?: number;
}

export const FormInputTextArea = ({ name, control, label, variant, labelColor, isDeactivated, helperText, rows }: FormInputTextAreaProps) => {
  if (variant == null) {
    variant = 'outlined';
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error }, formState }) => (
        <div data-test-id={`input-${name}-wrapper`}>
          <TextField
            inputProps={{ 'data-test-id': `input-${name}` }}
            helperText={error ? error.message : helperText ? helperText : ' '}
            error={!!error}
            size='small'
            onChange={onChange}
            value={value}
            fullWidth
            label={label}
            variant={variant}
            margin='normal'
            sx={{ color: labelColor }}
            disabled={isDeactivated}
            multiline
            rows={rows || 16}
          />
          {helperText && error && <HelperText>{helperText}</HelperText>}
        </div>
      )}
    />
  );
};
